export default __webpack_public_path__ + "static/media/leh.3825534a.jpg";